import React from "react";
import { useFeatureFlag } from "@jsq/flags-react";
import DistributionsPage from "./DistributionsPage";
import TransactionsPage from "./TransactionsPage";

/**
 * TransactionsPageSwitcher - Routes between the legacy DistributionsPage and the new
 * unified TransactionsPage based on the `treasuryPaymentIntegration` feature flag.
 *
 * Flag ON  → TransactionsPage (unified accounting payables list)
 * Flag OFF → DistributionsPage (legacy distributions-only view)
 *
 * This wrapper keeps routes.ts clean (static array) while satisfying the React hooks
 * rule that `useFeatureFlag` must be called inside a component, not at module scope.
 *
 * Arena context for flag evaluation is set globally at the app level via `useIdentifyArena`
 * in src/index.tsx, so no per-component arenaId is needed here.
 */
const TransactionsPageSwitcher: React.FC = () => {
  const isTransactionsEnabled = useFeatureFlag("treasuryPaymentIntegration", false);
  return isTransactionsEnabled ? <TransactionsPage /> : <DistributionsPage />;
};

export default TransactionsPageSwitcher;
